import React, { ChangeEvent } from 'react';
import { Trans } from 'react-i18next';
import { Checkbox, Typography } from '@material-ui/core';
import { TableCellProps } from 'react-virtualized';
import moment from 'moment';

import { getFullName } from 'helpers';

interface IOptions {
  className: string;
  checkedIds: string[];
  isAllChecked: boolean;
  onAllChecked: (event: ChangeEvent<HTMLInputElement>) => void;
  onChecked: (event: ChangeEvent<HTMLInputElement>) => void;
}

const PendingColumns = (options: IOptions) => {
  const { className, checkedIds, isAllChecked, onAllChecked, onChecked } = options;

  return [
    {
      dataKey: 'id',
      width: 70,
      className,
      muiHeaderCellProps: { padding: 'checkbox' },
      muiCellProps: { padding: 'checkbox' },
      headerContentRenderer: () => <Checkbox checked={isAllChecked} onChange={onAllChecked} />,
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Checkbox name={cellData} checked={checkedIds.includes(cellData)} onChange={onChecked} />
      ),
    },
    {
      dataKey: 'email_address',
      width: 300,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:to" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap title={cellData}>
          {cellData}
        </Typography>
      ),
    },
    {
      dataKey: 'added_by_user',
      width: 300,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="admin:invitedBy" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ rowData }: TableCellProps) => (
        <Typography noWrap title={getFullName(rowData.added_by_user)}>
          {getFullName(rowData.added_by_user)}
        </Typography>
      ),
    },
    {
      dataKey: 'created_at',
      width: 100,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="admin:lastSent" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap>{cellData ? moment.unix(cellData).format('l') : '--'}</Typography>
      ),
    },
  ];
};

export default PendingColumns;
